export const numberToCurrency = (number: number | undefined, format: boolean) : string => {
    if (number && !format) {
        return `€ ${number}`;
    } else if (number && format) {
        var formatter = new Intl.NumberFormat('nl-NL', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 0,
						minimumFractionDigits: 0
        });
        return formatter.format(number);
    }

		return '';
};


export const currencyToNumber = (value: string, mustBeNumber?: boolean, log?: boolean): number | string => {
	if (typeof value === 'number') return value;
	if (mustBeNumber && !value) return 0;
	let formattedValue: number | string = '';
	if (value) {
		formattedValue = value.replaceAll("€", "");
		formattedValue = formattedValue.replaceAll(/\./g,'');
		formattedValue = formattedValue.replaceAll(/\s/g, '');
		formattedValue = parseFloat(formattedValue as string);
		if(Math.round(formattedValue) !== formattedValue) {
			formattedValue = formattedValue.toFixed(2);
		}
		if (log) {
			console.log(formattedValue)
		}
		return Math.round(formattedValue as number);
	} else {
		return '';
	}
};

export const percentageToFloat = (value: string): number => {
	let formattedValue = value.replaceAll("%", "");
	formattedValue = formattedValue.replaceAll(",", ".")
	return parseFloat(formattedValue);
}


export const floatToPercentage = (value: number): string => {
	return value.toString().replace(".", ",");
}
